import { render, staticRenderFns } from "./CompanyInfoList.vue?vue&type=template&id=18859c37&scoped=true&"
import script from "./CompanyInfoList.vue?vue&type=script&lang=js&"
export * from "./CompanyInfoList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInfoList.vue?vue&type=style&index=0&id=18859c37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18859c37",
  null
  
)

export default component.exports